import Analytics from 'analytics';
import googleAnalytics from '@analytics/google-analytics';
import googleTagManager from '@analytics/google-tag-manager';
import { analyticsConfig } from '../data/analyticsConfig';

const plugins = [];

if (analyticsConfig.googleAnalyticsId) {
  plugins.push(googleAnalytics({ measurementIds: [analyticsConfig.googleAnalyticsId] }));
}

if (analyticsConfig.googleTagManagerId) {
  plugins.push(googleTagManager({ containerId: analyticsConfig.googleTagManagerId }));
}

/** True once at least one tracking id has been filled in in data/analyticsConfig.ts. */
export const isAnalyticsConfigured = plugins.length > 0;

const analytics = Analytics({ app: 'kat-diaz-portfolio', plugins });

/** Records a page view. Safe to call even when analytics isn't configured yet. */
export function trackPageView() {
  if (isAnalyticsConfigured) analytics.page();
}

/** Records a named visitor action, e.g. trackEvent('cv_download', { source: 'sidebar' }). */
export function trackEvent(name: string, payload?: Record<string, string | number | boolean>) {
  if (isAnalyticsConfigured) analytics.track(name, payload);
}
